export enum UserRole {
  ADMIN = "admin",
  WORKER = "user",
  SUPERADMIN = "super-admin",
}
